import { transport } from '../../transport/transport';

import { getConfig } from '../../config';
import { WixMpResponse } from '../../types/http-responses';
import { Experiments } from '../experiments.models';

export function getExperimentsFromServer() {
  return transport.get<WixMpResponse<Experiments>>(
    getConfig().api.experimentsUrl,
    {
      withCredentials: true,
      xsrfCookieName: undefined,
    },
  );
}
